<template>
  <div class="d-flex">
    <v-icon>filter_list</v-icon>
    <div>
      <v-chip
        v-for="chip in chips"
        :key="chip.key + '.' + chip.index"
        close
        @click:close="chip.remove()"
        class="ml-3"
      >
        <span>{{ $t("locations.filters." + chip.key) }}:&#160;</span>
        <span v-if="chip.key === 'status'">
          {{ $t("subscriptions.status." + chip.value) }}
        </span>
        <span
          v-else-if="
            chip.key === 'standardTopic' ||
              chip.key === 'premiumTopic' ||
              chip.key === 'topic'
          "
        >
          {{ topicItem(chip.value).name }}
        </span>
        <span v-else>{{ chip.value }}</span>
      </v-chip>
    </div>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn fab small icon v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="zip = true">
          {{ $t("locations.filters.zip") }}
        </v-list-item>
        <v-list-item @click="city = true">
          {{ $t("locations.filters.city") }}
        </v-list-item>
        <v-list-item @click="country = true">
          {{ $t("locations.filters.country") }}
        </v-list-item>
        <v-list-item @click="province = true">
          {{ $t("locations.filters.province") }}
        </v-list-item>
        <v-list-item @click="status = true">
          {{ $t("locations.filters.status") }}
        </v-list-item>
        <v-list-item @click="visibility = true">
          {{ $t("locations.filters.visibility") }}
        </v-list-item>
        <v-list-item @click="premium = true" v-show="!filters.premium">
          {{ $t("locations.filters.premium") }}
        </v-list-item>
        <v-list-item @click="topic = true">
          {{ $t("locations.filters.topic") }}
        </v-list-item>
        <v-list-item @click="standardTopic = true">
          {{ $t("locations.filters.standardTopic") }}
        </v-list-item>
        <v-list-item @click="premiumTopic = true">
          {{ $t("locations.filters.premiumTopic") }}
        </v-list-item>
        <v-list-item @click="standardTopicCount = true">
          {{ $t("locations.filters.standardTopicCount") }}
        </v-list-item>
        <v-list-item @click="premiumTopicCount = true">
          {{ $t("locations.filters.premiumTopicCount") }}
        </v-list-item>
      </v-list>
    </v-menu>
    <input-dialog
      :show="zip"
      :title="$t('locations.filters.zip')"
      @input="add('zip', $event)"
      @show="show('zip', $event)"
    />
    <input-dialog
      :show="city"
      :title="$t('locations.filters.city')"
      @input="add('city', $event)"
      @show="show('city', $event)"
    />
    <select-dialog
      :show="country"
      :title="$t('locations.filters.country')"
      :label="$t('locations.filters.country')"
      :items="countries"
      @input="add('country', $event)"
      @show="show('country', $event)"
    />
    <input-dialog
      :show="province"
      :title="$t('locations.filters.province')"
      @input="add('province', $event)"
      @show="add('province', $event)"
    />
    <select-dialog
      :show="status"
      :items="statusList"
      :title="$t('locations.filters.status')"
      :label="$t('locations.filters.status')"
      @input="add('status', $event)"
      @show="show('status', $event)"
    />
    <input-dialog
      :show="visibility"
      :title="$t('locations.filters.visibility')"
      @input="add('visibility', $event)"
      @show="show('visibility', $event)"
    />
    <select-dialog
      :show="standardTopic"
      :items="topics"
      item-text="name"
      item-value="uid"
      :title="$t('locations.filters.standardTopic')"
      :label="$t('locations.filters.standardTopic')"
      @input="add('standardTopic', $event)"
      @show="show('standardTopic', $event)"
    />
    <select-dialog
      :show="premiumTopic"
      :items="topics"
      item-text="name"
      item-value="uid"
      :title="$t('locations.filters.premiumTopic')"
      :label="$t('locations.filters.premiumTopic')"
      @input="add('premiumTopic', $event)"
      @show="show('premiumTopic', $event)"
    />
    <select-dialog
      :show="topic"
      :items="topics"
      item-text="name"
      item-value="uid"
      :title="$t('locations.filters.topic')"
      :label="$t('locations.filters.topic')"
      @input="add('topic', $event)"
      @show="show('topic', $event)"
    />
    <switch-dialog
      :show="premium"
      :title="$t('locations.filters.premium')"
      @input="add('premium', $event)"
      @show="show('premium', $event)"
    />
    <input-dialog
      :show="standardTopicCount"
      type="number"
      :title="$t('locations.filters.standardTopicCount')"
      @input="add('standardTopicCount', $event)"
      @show="show('standardTopicCount', $event)"
    />
    <input-dialog
      :show="premiumTopicCount"
      type="number"
      :title="$t('locations.filters.premiumTopicCount')"
      @input="add('premiumTopicCount', $event)"
      @show="show('premiumTopicCount', $event)"
    />
  </div>
</template>

<script>
import InputDialog from "@/components/shared/InputDialog";
import SelectDialog from "@/components/shared/SelectDialog";
import SwitchDialog from "@/components/shared/SwitchDialog";

export default {
  props: {
    value: { type: Object, required: true }
  },
  data() {
    return {
      filters: this.value,
      zip: false,
      city: false,
      country: false,
      province: false,
      status: false,
      visibility: false,
      premium: false,
      topic: false,
      standardTopic: false,
      premiumTopic: false,
      standardTopicCount: false,
      premiumTopicCount: false,
      countries: [
        { text: this.$t("countries.AT"), value: "AT" },
        { text: this.$t("countries.DE"), value: "DE" }
      ],
      statusList: [
        { text: this.$t("subscriptions.status.PENDING"), value: "PENDING" },
        { text: this.$t("subscriptions.status.ACTIVE"), value: "ACTIVE" },
        { text: this.$t("subscriptions.status.ON_HOLD"), value: "ON_HOLD" },
        { text: this.$t("subscriptions.status.CANCELLED"), value: "CANCELLED" },
        { text: this.$t("subscriptions.status.SWITCHED"), value: "SWITCHED" },
        { text: this.$t("subscriptions.status.EXPIRED"), value: "EXPIRED" },
        {
          text: this.$t("subscriptions.status.PENDING_CANCEL"),
          value: "PENDING_CANCEL"
        }
      ],
      topics: null
    };
  },
  computed: {
    chips() {
      return Object.keys(this.filters)
        .map(k => {
          if (!this.filters[k]) return [];

          if (!Array.isArray(this.filters[k])) {
            this.$delete(this.filters, k);
            return [];
          }

          return this.filters[k].map((v, i) => {
            const that = this;
            return {
              key: k,
              value: v,
              index: i,
              remove: () => {
                that.filters[k].splice(i, 1);
                if (!that.filters[k] || that.filters[k].length < 1) {
                  that.$delete(that.filters, k);
                }
              }
            };
          });
        })
        .flat();
    }
  },
  created() {
    this.$store.dispatch("topics/list").then(t => (this.topics = t));
  },
  components: {
    InputDialog,
    SelectDialog,
    SwitchDialog
  },
  methods: {
    show(field, value) {
      this.$set(this, field, value);
    },
    add(field, val) {
      if (!this.filters[field]) {
        this.$set(this.filters, field, [val]);
      } else {
        this.filters[field].push(val);
      }
      this.show(field, false);
    },
    topicItem(uid) {
      return !this.topics ? {} : this.topics.find(t => t.uid === uid);
    }
  }
};
</script>

<style></style>
